<template>
  <div v-if="getSidebarStatus"
       class="SideBarModules"
       :class="{ 'isActive': getSidebarStatus }">
    <div class="SideBarModules_header d-flex justify-content-end p-2 border-bottom border-dark">
      <button v-b-tooltip.hover.right="'Fechar Menu'"
              v-ripple
              class="SideBarModules_btnClose border-0 bg-transparent"
              type="button"
              @click="closeSidebar">
        <icon-svg icon="close"
                  class="SideBarModules_btnClose_icon icon--xs" />
      </button>
    </div>

    <b-card v-for="(option, index) in module.menu"
            :key="index"
            class="card_menu p-0 m-0"
            no-body>
      <div 
        v-ripple
        class="p-0 m-0">
        <ul class="SideBarModules_list">
          <li v-b-toggle="`accordion-${index}`"
              class="SideBarModules_list_item p-0"
              block>
            <button :class=" handlerPrivateModules(option) ? 
                      'SideBarModules_list_button border-0 p-3 m-0 w-100' : 
                      'SideBarModules_list_button_disabled border-0 p-3 m-0 w-100'"
                    type="button"
                    :disabled="!handlerPrivateModules(option)"
                    @click="click(option)">
              {{ option.title }}
              <svg v-if="option.options"
                   class="SideBarModules_list_button_arrow icon--xs"
                   :class="{ 'SideBarModules_list_button_arrow_active': (opened === `accordion-${index}`)}"
                   role="presentation">
                <use :xlink:href="'#' + arrowIcon.id" />
              </svg>
            </button>
          </li>
        </ul>
      </div>
      <b-collapse :id="`accordion-${index}`"
                  role="tabpanel"
                  class="p-0 m-0">
        <div v-if="option.options"
             class="p-0 m-0">
          <ul class="SideBarModules_list p-0">
            <li v-for="(submenu, index) in option.options"
                :key="index"
                v-ripple
                class="SideBarModules_list_button">
              <button class="SideBarModules_list_button border-0 p-3 m-0 w-100"
                      type="button"
                      :class="{ 'SideBarModules_list_button_disabled': 
                        !!submenu.disabled || !handlerPrivateModules(option)}"
                      :disabled="!!submenu.disabled || !handlerPrivateModules(option)"
                      @click="click(submenu)">
                <div class="pl-2">
                  {{ submenu.title }}
                </div>
              </button>
            </li>
          </ul>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import closeIcon from '@/assets/icons/close.svg?sprite'
  import arrowIcon from '@/assets/icons/arrow-down.svg?sprite'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SideBarModules',
    props: {
      module: Object
    },
    data () {
      return {
        closeIcon,
        arrowIcon,
        opened: false,
        cartorioObj: null
      }
    },
    computed: {
      ...mapGetters({
        getSidebarStatus: 'auth/isSidebarOpen',
      }),
    },
    async mounted () {
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
        this.opened = isJustShown ? collapseId : false
      })
      this.cartorioObj = this.$store.state.auth.cartorioObj
    },
    methods: {
      closeSidebar (e) {
        this.$store.dispatch('auth/openSidebar', false).then(res => res)
        if (e) return e.target.blur()
      },
      async click (option) {
        if (option.title === 'Visualizar existentes') {
          this.$store
            .dispatch('statusDosSelos/setSelosNaoEnviados', false)
            .then(res => res)
          this.$store
            .dispatch('statusDosSelos/setContagemDeExibicaoDeTodosOsSelos', 1)
            .then(res => res)
        }

        if (option.path) {
          this.$router.push(option.path).catch(()=>{})
          this.closeSidebar()
        }
      },
      handlerPrivateModules (option) {
        if (this.cartorioObj) {
          if (option.title === 'Mensalistas' && !this.cartorioObj.mensalista) return false
          if (option.title === 'Frente de Caixa' && !this.cartorioObj.frente_caixa) return false
          return true
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../scss/_utilities/_exports';

  .SideBarModules {
    @include scrollbars(pxToRem(8), $color-gray);
    background-color: $color-white;
    bottom: 0;
    display: inline-block;
    left: 0;
    position: fixed;
    transition: width .14s ease-in-out;
    @include transform(left left);
    text-align: left;
    top: 0;
    width: 0;
    overflow: auto;

    &_header {
      background-color: $color-logo;
      fill: white;
      height: 70px;
    }

    &_list {
      list-style: none;
      padding: 0;
      margin:0;

      &_button {
        background-color: $color-white;
        outline: none;
        color: $color-logo;
        text-align: start;
        border-top: 2px solid rgba(0, 0, 0, 0.125);

        &_disabled {
          text-align: start;
          color: #12121257;
        }

        &_arrow {
          fill: $color-logo;
          float: right;
          vertical-align:baseline;
        }

        &_arrow_active {
          fill:rgb(154, 154, 154);
          transform: rotate(180deg);
        }

        &:hover, &:focus {
          color: white;
          background-color: $color-logo;
          outline: none;

          .SideBarModules_list_button_arrow {
            fill: white;
          }
        }
        .SideBarModules_list_button_arrow_active {
          fill: $color-logo;
        }
      }
    }

    &_btn {
      &--sofia {
        max-width: pxToRem(200);
      }
    }

    &.isActive {
      width: pxToRem(260);
      z-index: 120;
    }
  }

  .card_menu {
    margin: 0;
  }
</style>
